import { gql } from '@apollo/client'

export const GET_LOTS_BY_LAT_LON = gql`
    query booking_get_lots($latitude: Float!, $longitude: Float!) {
        booking_get_lots(latitude: $latitude, longitude: $longitude) {
            id
            name
            address
            proximity_meters
            latitude
            longitude
        }
    }
`
